<script>
export default {
  name: "CrmTabBar",
  props: {
    tabs: {
      type: Array,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    dataTestPrefix: {
      type: String,
      required: true
    }
  },
  emits: ["change"]
};
</script>

<template>
  <div class="crm-tab-bar" role="tablist">
    <button
      v-for="tab in tabs"
      :key="tab.value"
      type="button"
      :class="['crm-tab-bar__tab', { 'is-active': value == tab.value }]"
      :data-test="`${dataTestPrefix}-${tab.key}`"
      @click="$emit('change', tab.value)"
      :data-lang="tab.key"
    >
      {{ tab.label }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
.crm-tab-bar {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  border-bottom: 1px solid #e5e5e5;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.crm-tab-bar::-webkit-scrollbar {
  display: none;
}

.crm-tab-bar__tab {
  flex: 1 0 auto;
  height: 48px;
  padding: 0 16px;
  border: 0;
  border-bottom: 3px solid transparent;
  background: transparent;
  color: #b3b3b3;
  font-size: var(--font-body-lg);
  font-weight: 700;
  white-space: nowrap;
}

.crm-tab-bar__tab.is-active {
  border-bottom-color: var(--primary-color);
  color: var(--primary-color);
}
</style>
